import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/health/health-heart-line/health-heart-line.component.js'

const tagName = 'dap-ds-icon-heart-line'

/**
 * `dap-ds-icon-heart-line`
 * @summary An icon
 * @element dap-ds-icon-heart-line
 * @title - HealthHeartLine
 * @group icon
 * @icontype health
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'HealthHeartLine',
})

export default reactWrapper
